module.exports = __webpack_public_path__ + "img/about_img.5fe961bb.png";